import React from 'react';

import { StaticQuery } from 'gatsby';

import Header from './Header';
import Footer from './Footer';

import { Helmet } from 'react-helmet';
import styles from './Layout.module.scss';

import Config from '../../gatsby-config';

const LayoutTemplate = ({
  children,
  absoluteMenu,
  seoTitle,
  seoDescription,
  seoImage
}) => {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={`${Config.siteMetadata.siteUrl}/`} />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={`${Config.siteMetadata.siteUrl}${seoImage.childImageSharp.fixed.src}`}
        />
        <meta name="twitter:card" content="summary_large_image" />

        {/*<link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />*/}
        {/*<meta
          property="og:image"
          content={`${withPrefix('/')}img/og-image.jpg`}
        />*/}
      </Helmet>
      <Header absolute={absoluteMenu} />
      <main>{children}</main>
      <Footer />
    </>
  );
};

const Layout = ({ children, absoluteMenu }) => {
  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          items: markdownRemark(frontmatter: { type: { eq: "seo-vars" } }) {
            frontmatter {
              seoTitle
              seoDescription
            }
          }
          indexMeta: markdownRemark(
            frontmatter: { templateKey: { eq: "index-page" } }
          ) {
            frontmatter {
              image {
                childImageSharp {
                  fixed(width: 800) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          }
        }
      `}
      render={({ items, indexMeta }) => (
        <LayoutTemplate
          absoluteMenu={absoluteMenu}
          seoTitle={items.frontmatter.seoTitle}
          seoDescription={items.frontmatter.seoDescription}
          seoImage={indexMeta.frontmatter.image}
        >
          {children}
        </LayoutTemplate>
      )}
    />
  );
};

export default Layout;
